import {useQuery} from '@apollo/client'
import {usePointOfInterest} from '../../../../../store/hooks/pointOfInterest'
import {usePoiConfig} from '../PopulationDensityHelper'
import {getPOIQuery, statesToAbbreviation} from '../helpers'
import {useStatesAndHealthConditions} from '../../../../../store/hooks/breadCrumbs'
import {getState} from '../../../../../shared/helpers/getState'

export function useGetPOI(mapBounds) {
  const poiConfig = usePoiConfig()
  const {selectedPOI} = usePointOfInterest()
  const {filters} = useStatesAndHealthConditions()
  const currentStateFromContext = filters && getState(filters)

  const {
    data: poiData,
    loading: loadingPOI,
    error: errorPointOfInterest,
    refetch: refetchPointOfInterest
  } = useQuery(getPOIQuery(selectedPOI, poiConfig), {
    variables: {
      filters: {
        state:
          Array.isArray(currentStateFromContext) &&
          currentStateFromContext.map((stateVal) => statesToAbbreviation[stateVal])
      }
    },
    skip: selectedPOI?.length === 0,
    notifyOnNetworkStatusChange: true
  })

  return {poiData, loadingPOI, errorPointOfInterest, refetchPointOfInterest}
}

/**
 * List of functions and their purpose:
 *
 * - getPOI: Executes a GraphQL query to fetch points of interest (POI) data within the map bounds based on selected filters and configurations.
 */
